var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_3012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6958 6.99999H14.0001C14.0001 6.36818 13.9159 5.75612 13.759 5.17389H6.6958V6.99999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6958 3.34783H12.9727C12.5442 2.64859 11.9963 2.03054 11.3575 1.52173H6.6958V3.34783Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 14C8.6474 14 10.1616 13.4306 11.3574 12.4783H2.64258C3.83832 13.4306 5.35254 14 6.99997 14Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02748 10.6522H12.9727C13.3167 10.0908 13.5835 9.47723 13.7589 8.82607H0.241211C0.416676 9.47723 0.683469 10.0908 1.02748 10.6522Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24253 1.09315H3.88043L3.28707 1.52422L3.51373 2.22173L2.92039 1.79066L2.32706 2.22173L2.52284 1.61916C2.00041 2.05434 1.54252 2.56419 1.16517 3.13228H1.36957L0.991867 3.40668C0.933023 3.50484 0.876586 3.60456 0.8225 3.70576L1.00286 4.26087L0.666367 4.01639C0.582723 4.1936 0.506215 4.37481 0.437445 4.55979L0.636152 5.17141H1.36957L0.776207 5.60249L1.00286 6.3L0.409527 5.86893L0.0541133 6.12716C0.0185391 6.41312 0 6.70439 0 7H7C7 3.13403 7 2.67827 7 0C5.61717 0 4.32811 0.401133 3.24253 1.09315ZM3.51373 6.3L2.92039 5.86893L2.32706 6.3L2.55371 5.60249L1.96036 5.17141H2.69377L2.92039 4.4739L3.14702 5.17141H3.88043L3.28707 5.60249L3.51373 6.3ZM3.28707 3.56336L3.51373 4.26087L2.92039 3.82979L2.32706 4.26087L2.55371 3.56336L1.96036 3.13228H2.69377L2.92039 2.43477L3.14702 3.13228H3.88043L3.28707 3.56336ZM6.02459 6.3L5.43126 5.86893L4.83793 6.3L5.06458 5.60249L4.47122 5.17141H5.20464L5.43126 4.4739L5.65789 5.17141H6.3913L5.79794 5.60249L6.02459 6.3ZM5.79794 3.56336L6.02459 4.26087L5.43126 3.82979L4.83793 4.26087L5.06458 3.56336L4.47122 3.13228H5.20464L5.43126 2.43477L5.65789 3.13228H6.3913L5.79794 3.56336ZM5.79794 1.52422L6.02459 2.22173L5.43126 1.79066L4.83793 2.22173L5.06458 1.52422L4.47122 1.09315H5.20464L5.43126 0.395637L5.65789 1.09315H6.3913L5.79794 1.52422Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_3012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/Usd.ee69fecec60b491fe9f5a498b712c289.svg";
export { ForwardRef as ReactComponent };